/**
 * <hero-rotator> — rotating product showcase for the flagship hero.
 * One slide visible; on tick the current slides out left and the next slides in
 * from the right. Order is shuffled per page load so the above-the-fold is
 * (almost) never the same twice. Pauses on hover; static under reduced-motion.
 */
if (!customElements.get('hero-rotator')) {
  class HeroRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length <= 1) return;

      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.index = 0;

      if (this.dataset.shuffle === 'true') this.shuffle();

      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });
    }

    shuffle() {
      for (let k = this.slides.length - 1; k > 0; k--) {
        const j = Math.floor(Math.random() * (k + 1));
        [this.slides[k], this.slides[j]] = [this.slides[j], this.slides[k]];
      }
      // re-append in shuffled order
      this.slides.forEach((s) => this.appendChild(s));
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }

    next() {
      const current = this.slides[this.index];
      const nextIndex = (this.index + 1) % this.slides.length;
      const next = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-exit');
      next.classList.remove('is-exit');
      next.classList.add('is-active');

      // once the exiting slide is offstage, return it to the idle (incoming-right) state
      window.setTimeout(() => current.classList.remove('is-exit'), 680);

      this.index = nextIndex;
    }

    disconnectedCallback() {
      this.stop();
    }
  }
  customElements.define('hero-rotator', HeroRotator);
}
